import { defineStore } from "pinia";
import { getInstance } from "../api/api";
import { showErrorNotifications, showErrorModal, showToastSuccess, showToastWarning } from "../services/popups";
const api = getInstance();
export const usePatientStore = defineStore('patient', {
  inject:["mySpinner"],
  state: () => {
    return {
      patients:[], 
      imutablePatients:[],
      patient:{},
      showMessageNameExists:false,
      getPatientHumorIndicatorsOutput:{chartIndicators:[]},
      patientsMedicalRecords:[],
      selectedPatientMedicalRecord:{},
    }          
  },
  actions: {
    targetPatientById(patientId) {
      let found = this.patients.find(pat => pat.id === patientId);

      if (!found) { return; }

      this.patient = found;
    },
    setPatients(patients) {
      this.patients = patients;
      if (this.patients.length == 0) {return;}
      
    },        
    addPatient(patient) {      
      patient.name = patient.name.toUpperCase();
      this.patients.unshift(patient);
      this.patients.sort((a, b) => (b.name > a.name) ? -1 : ((a.name > b.name) ? 1 : 0));
    },        
    updatePatient(patient) {
      if (this.patients.length == 0) {return;}

      let indexFound = this.patients.findIndex(x => x.id == patient.id);

      if (indexFound == -1) {return;}
      
      patient.name = patient.name.toUpperCase();

      this.patients[indexFound] = patient;
    },                
    markAsVisualizedUnreadReport(patientId) {
      if (this.patients.length == 0) {return;}

      let indexFound = this.patients.findIndex(x => x.id == patientId);

      if (indexFound == -1) {return;}            

      this.patients[indexFound].unreadReports = this.patients[indexFound].unreadReports - 1;
    },   
    clean() {
      this.showMessageNameExists = false;
      this.patient = {
        id:"",
        name:"",
        email:"",
        phone:"",
        phone2:"",
        payday:0,
        sessionValue:0,
        numberOfSessions:0,
        situation:0,
        birthDate:"",
        note:""
    }
    },
    getPatientName(patientId) {
      if (this.patients.length == 0) {return;}

      let indexFound = this.patients.findIndex(x => x.id == patientId);

      if (indexFound == -1) {return;}            

      return this.patients[indexFound].name;
    },
    filterPatients(name) {      
      if (!name) {
        this.patients = this.imutablePatients;
        return;
      }

      name = name.toUpperCase();

      this.patients = this.imutablePatients.filter(patient => {        
        if (patient.name.includes(name)) { return patient; }
      });      
    },   
    async getPatients(clinicId) {
      try {                                         
        let response = await api.get("v1/Patient/Summary", { params: { clinicId } })          
        if (response.data.success) {
          response.data.data.sort((a, b) => (b.name > a.name) ? -1 : ((a.name > b.name) ? 1 : 0));
          this.patients = response.data.data;
          this.imutablePatients = response.data.data;
        }
      } catch {           
        return;
      }
    },     
    async getPatientById(patientId) {
      try {
        let response = await api.get("v1/Patient", { params: {patientId} });
        
        if (response.data.success) {            
          response.data.data.birthDate = response.data.data.birthDate.split('T')[0]; 
          this.patient = response.data.data;                   
        }
      } catch {
        return;
      }
    },
    async postPatient(patient) {
      try {        
        let response = await api.post("v1/Patient", {...patient})
        if (!response.data.success) {
          if (response.data.notifications)
            showErrorNotifications(response.data.notifications);
          else
            showErrorModal(response.data.message);
        }
        else {          
          this.patient.id = response.data.data;
          this.addPatient(this.patient);
          this.$router.push("/patients");
          showToastSuccess("Paciente cadastrado com sucesso!");
        }
      } catch {
        return;
      }
    },
    async putPatient(patient) {
      try {        
        let response = await api.put("v1/Patient", {...patient});        
        if (!response.data.success) {
          if (response.data.notifications)
          {            
            showErrorNotifications(response.data.notifications);
          }
          else
            showErrorModal(response.data.message);
        }
        else {                                
          this.$router.push("/patients");
        }
      } catch {
        return false;          
      }  
    },
    async patientNameExists(name) {
      if (!name) {this.showMessageNameExists = false;}      
      let response = await api.get("v1/User/NameExists", { params: {name} });
      if (response.data.success) {             
        this.showMessageNameExists =  response.data.data;
      }
      else {
        this.showMessageNameExists = false;
      }
    },
    async getPatientHumorIndicators(patientId) {
      try {
        let response = await api.get("v1/Patient/HumorIndicators", {params : { patientId }});          

        if (response.data.success) {
          this.getPatientHumorIndicatorsOutput = response.data.data;
        }
        
      } catch {
        return;
      }
    },
    async getPatientMedicalRecords(patientId){
      const response = await api.get(`/v1/Patient/${patientId}/MedicalRecord/Summary`);
      if(response.status == 200){
        if(response.data.data != null){
          this.patientsMedicalRecords = response.data.data
          return true;
        }else{
          this.patientsMedicalRecords = [];
        }
      }
      return false;
    },
    async postPatientMedicalRecord(patientId, title, description){
      const response = await api.post(`/v1/Patient/${patientId}/MedicalRecord`,
      {
        "title": title,
        "description": description
      });
      if(response.status == 200){
        if(response.data.notifications){
          showErrorNotifications(response.data.notifications);
        }
        if(!response.data.success){
          showToastWarning(response.data.message);
          return;
        }

        this.patientsMedicalRecords.unshift({
          createdAt: new Date(),
          id: response.data.data,
          title: title.toUpperCase()
        });
        
        showToastSuccess(response.data.message);
        this.$router.push(`/patients/${patientId}/records`);
      }
    },
    async getPatientMedicalRecord(patientId, idMedicalRecord){
      const response = await api.get(`/v1/Patient/${patientId}/MedicalRecord/Summary/${idMedicalRecord}`);
      if(response.status == 200){
        this.selectedPatientMedicalRecord = response.data.data;
      }
    },
    async putPatientMedicalRecord(patientId, idMedicalRecord, title, description){
      const response = await api.put(`/v1/Patient/${patientId}/MedicalRecord`, {
        "id": idMedicalRecord,
        "title": title,
        "description": description
      });
      if(response.status == 200){
        if(response.data.notifications){
          showErrorNotifications(response.data.notifications);
          return;
        }
        if(!response.data.success){
          showErrorNotifications(response.data.message);
          return;
        }
        showToastSuccess(response.data.message);
        this.$router.push(`/patients/${patientId}/records`);
      }
    }
  },    
});    
